var React = require('react');

function SkiLift (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M488 288a24.07 24.07 0 0 0-24 24 33.54 33.54 0 0 1-21.8 31.3L111.65 465.5a24 24 0 1 0 16.6 45l330.5-122.1A81.87 81.87 0 0 0 512 312a24 24 0 0 0-24-24zM112 128a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm79.6 253.4a24 24 0 1 0-15.2-45.6L158 342a40 40 0 0 1-48.7-20.7l-63.6-133A24 24 0 1 0 2.35 209L66 342a88.31 88.31 0 0 0 79.5 50c12.55 0 16.95-.9 46.05-10.6zM256 0h-32v184l32-8z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M307.65 222.8a31.61 31.61 0 0 0-27.5-5.8l-68.3 17-24.1-53.7a48 48 0 1 0-87.6 39.4L128 287.8c7.9 19.1 22.7 27.6 39.8 23.3L256 289v123.2l64-23.7V248a31.69 31.69 0 0 0-12.35-25.2z","className":"fa-primary","key":2})]);
}

SkiLift.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = SkiLift;

SkiLift.default = SkiLift;
